import axios                        from 'axios';
import router                       from '@/router';
import { useField, useForm }        from 'vee-validate';
import { onMounted, ref }           from "vue";
import * as yup                     from 'yup';
import YupPassword                  from 'yup-password';
import { API_BASE_URL }             from '@/assets/js/common/app-config';
import { updateAuthorizationToken } from '@/assets/js/common/http-common';
import { formatServerError }        from '@/assets/js/utils/apiErrors';

YupPassword(yup)

const EMAIL_INSTITUCIONAL_REGEX = /@(aluno\.humanitas\.edu\.br|humanitas\.edu\.br|ecbr\.org\.br)$/i;

export default {

  name: 'Login',

  data: () => ({
    checkPwd: '',
    emailReset: '',
    isFormValid: false,
    loadingChangePwd: false,
    loadingResetPwd: false,
    loadingSignIn: false,
    passwordRules: [
      v => !!v || 'O campo é obrigatório.',
      v => (v && /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}$/.test(v)) || 
      'A senha precisa conter 8 ou mais caracteres com pelo menos um de cada: letra maiúscula, letra minúscula, número e caractere especial.'
    ],
    pwd: '',
    requiredField: [v => !!v || 'O campo é obrigatório.'],
    requiredEmail: [
      v => !!v || 'O campo é obrigatório.',
      v => /.+@.+\..+/.test(v) || /.+@localhost$/i.test(v) || 'E-mail inválido.',
    ],
    show1: false,
    show2: false,
    step: 1,
    username: ''
  }),

  setup() {

    const baseURL = API_BASE_URL;

    const alert         = ref(false);
    const alertType     = ref(null);
    const alertText     = ref('');
    const loadingSignUp = ref(false);
    //const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/
    const phoneRegExp   = /^\(\d{2}\) \d{4,5}-\d{4}$/;

    const validationSchema = yup.object().shape({
      nome: yup.string().required('O nome é obrigatório.').min(2, 'O nome precisa ter pelo menos 2 caracteres.'),
      sexo: yup.mixed().oneOf(['m', 'f', 'ni']).defined('Selecione uma opção.'),
      fone: yup.string().required('O telefone é obrigatório.').matches(phoneRegExp, 'Número de telefone inválido.'),
      cpf: yup
        .string()
        .required('O CPF é obrigatório.')
        .matches(/^\d{11}$/, 'CPF inválido. Deve conter exatamente 11 dígitos numéricos.'),
      email: yup
        .string()
        .required('O e-mail é obrigatório.')
        .email('E-mail inválido.')
        .matches(
          EMAIL_INSTITUCIONAL_REGEX,
          'Use um e-mail institucional (@aluno.humanitas.edu.br, @humanitas.edu.br ou @ecbr.org.br).',
        ),
      ra: yup.string().required('Informe o RA do aluno.').max(40, 'O RA deve ter no maximo 40 caracteres.'),
      turma_id: yup.number().typeError('Selecione sua turma.').required('Selecione sua turma.'),
    });

    const { handleSubmit, handleReset } = useForm({
      validationSchema,
    });

    const nome         = useField('nome')
    const sexo         = useField('sexo')
    const fone         = useField('fone')
    const cpf          = useField('cpf')
    const email        = useField('email')
    const ra           = useField('ra')
    const turma_id     = useField('turma_id')

    const items2 = ref([
      { tipo: 'm', nome: 'Masculino' },
      { tipo: 'f', nome: 'Feminino' },
      { tipo: 'ni', nome: 'Não desejo informar' },
    ])

    const turmasCadastro = ref([])

    onMounted(async () => {
      try {
        const response = await axios.get(baseURL + '/usuario/cadastro/turmas');
        turmasCadastro.value = response.data || [];
      } catch (error) {
        turmasCadastro.value = [];
      }
    })

    const onSubmit = handleSubmit(async (values) => {

      loadingSignUp.value = true;

      const vnome         = nome.value.value;
      const vgenero       = sexo.value.value;
      const vfone         = fone.value.value.replace(/\D/g, '');
      const vcpf          = cpf.value.value.replace(/\D/g, '');
      const vemail        = email.value.value.trim().toLowerCase();
      const vra           = (ra.value.value || '').trim();
      const vturmaId      = turma_id.value.value;
      const vusername     = vemail.substring(0, vemail.indexOf("@"));

      await axios.post(baseURL + '/usuario/create', {
        tipo_usuario: 'aluno', nome: vnome, genero: vgenero, telefone: vfone, cpf: vcpf,
        email: vemail, ra: vra, turma_id: vturmaId, username: vusername
      }).then(response => {
        alertType.value = 'success';
        alertText.value = response?.data?.message || 'Cadastro realizado! Verifique seu e-mail para definir sua senha de primeiro acesso.';
      }).catch(error => {
        alertType.value = 'error';
        alertText.value = formatServerError(
          error?.response?.data,
          'Nao foi possivel cadastrar o aluno. Verifique os dados e tente novamente.',
        );
      })
      handleReset();
      alert.value        = true;
      loadingSignUp.value =false;
    });

    return {
      baseURL, alert, alertType, alertText, loadingSignUp,
      nome, sexo, items2, fone, cpf, email, ra, turma_id, turmasCadastro,
      onSubmit, handleReset,
    };

  },
  
  mounted() {
    
    if (this.$route.params.token === 'token' && typeof this.$route.params.id !== 'undefined') {
      this.step = 4;
    }
    else if (this.$route.params.token !== 'token' && typeof this.$route.params.id !== 'undefined') {
      this.alertType = this.$route.params.token;
      this.alertText = this.$route.params.id;
      this.alert     = true;
    }

  },

  computed: {
    currentStep() {
        return this.step;
    },
    passwordConfirmationRule() {
      return () => (this.pwd === this.checkPwd) || 'As senhas precisam ser idênticas.'
    },
  },

  watch: {
    currentStep(newVal, oldVal) {
        this.alert     = false;
        this.alertText = '';
        this.alertType = null;
    },
  },

  methods: {
    getLoginErrorMessage(error) {
      const status = error.response?.status;

      if (status === 429) {
        const detail = error.response?.data?.detail || '';
        const match = detail.match(/(\d+)\s*second/i);
        if (match) {
          return `Muitas tentativas de login. Tente novamente em ${match[1]} segundos.`;
        }
        return 'Muitas tentativas de login. Aguarde um momento e tente novamente.';
      }

      return 'Erro ao fazer login. Verifique seu e-mail e senha.';
    },

    async onSubmitLogin() {
      this.loadingSignIn = true;
      const { valid } = await this.$refs.formLogin.validate();
      if (valid) {
        await axios.post(this.baseURL + '/auth/', { email: this.username, password: this.pwd }).then(response => {
          localStorage.setItem('token', response.data.access);
          updateAuthorizationToken(localStorage.getItem('token'));
          router.push('/');
        }).catch(error => {
          this.$refs.formLogin.reset();
          this.alertType = 'error';
          this.alertText = this.getLoginErrorMessage(error);
          this.alert     = true;
        })
      }
      this.loadingSignIn = false;
    },

    async onSubmitChangePwd() {
      this.loadingChangePwd = true;
      const { valid } = await this.$refs.formChangePwd.validate();
      if (valid) {
        await axios.post(this.baseURL + '/usuario/password_reset/confirm/', {password: this.pwd, token: this.$route.params.id}).then(response => {
          this.alertType = 'success';
          this.alertText = 'Senha alterada com sucesso!';
          router.push('/');
        }).catch(error => {
          this.alertType = 'error';
          this.alertText = error.message;
        })
        this.$refs.formChangePwd.reset();
        this.$refs.formChangePwd.reset();
        this.alert = true;
      }
      this.loadingChangePwd = false;
    },

    async onSubmitResetPwd() {
      this.loadingResetPwd = true;
      const { valid } = await this.$refs.formResetPwd.validate();
      if (valid) {
        await axios.post(this.baseURL + '/usuario/password_reset/', { email: this.emailReset }).then(response => {
          this.alertType = 'success';
          this.alertText = 'Foi enviado um e-mail de recuperação de senha.';
        }).catch(error => {
          this.alertType = 'error';
          const responseData = error?.response?.data;
          const serverMessage =
            responseData?.detail ||
            responseData?.error ||
            responseData?.email?.[0];

          this.alertText =
            serverMessage ||
            'Não foi possível enviar o e-mail de recuperação de senha. Verifique a conexão com o servidor e tente novamente.';
        })
        this.$refs.formResetPwd.reset();
        this.$refs.formResetPwd.resetValidation();
        this.alert = true;
      }
      this.loadingResetPwd = false;
    },
  },
};

